import { render, staticRenderFns } from "./Moni4.vue?vue&type=template&id=67942415&scoped=true&"
import script from "./Moni4.vue?vue&type=script&lang=js&"
export * from "./Moni4.vue?vue&type=script&lang=js&"
import style0 from "./Moni4.vue?vue&type=style&index=0&id=67942415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67942415",
  null
  
)

export default component.exports